var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-primary",attrs:{"href":"#","onclick":"FB.CustomerChat.showDialog()"}},[_vm._v("Any Questions?")])
}
var staticRenderFns = []

export { render, staticRenderFns }